<template>
    <v-col class="line" v-if="!title"> 
        <span class="bold" v-if="hideBr(elt.type)"><v-chip small label :color=getColor(elt?.currentWonum) text-color="white">{{ elt?.type }}</v-chip></span><br v-if="hideBr(elt.type)" />
        <span >{{ elt?.frequency }} {{ unit(elt?.unit) }}</span><br />
        <span>{{ formatNumber(elt?.value,0) }} {{ getRmUnit(elt?.unit) }} </span><br />
        <span>{{ formatdate(elt?.nextDate) }}</span>
    </v-col>
    <v-col class="line" v-else>
        <span class="bold" v-if="hideBr(elt.type)">{{ elt?.type }}</span><br v-if="hideBr(elt.type)" />
        <span ><b>Frequency</b></span><br />
        <span><b>Remaining</b></span><br />
        <span><b>Next due date</b></span>
    </v-col>
</template>

<script>
import { formatMagicDate, arrondirDecimales } from "@/shared/DateHelper";
export default {
    name: 'JobPlanElement',

    props: ["elt","title"],

    mounted() {

    },

    methods: {
        unit(value) {
            if (value == 'MILEAGE') {
                return 'Km'
            }
            return value
        },

        getRmUnit(value) {
            if (value == 'MILEAGE') {
                return 'Km'
            }
            return "Days"
        },

        getColor(value){
            if(value == null){
                return "#00475a";
            }
            return "#ff0000"
        },

        hideBr(value) {
            if (value == "BR 1.2") {
                return false
            }
            return true
        },

        formatNumber(a,b){
            return arrondirDecimales(a,b)
        },

        formatdate(date) {

            if (date == null) {
                return "N/A"
            }
            return formatMagicDate(date);
        }
    },
};
</script>

<style  scoped>
.line {
    padding-bottom: 10px;
    padding-top: 0px;
    white-space: nowrap;
    overflow: hidden;
    font-size: 12px;
}

.bold {
    font-weight: bold;
    color: #00475a;
}
</style>